import React from "react";
import "./Core_team.css";
import Common_title from "../../common-components/common-title/Common_title";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope } from "@fortawesome/free-regular-svg-icons";
import { faPhone } from "@fortawesome/free-solid-svg-icons";

const Core_team = () => {
  return (
    <>
      <section className="Core_team_section">
        <div className="container">
          <Common_title
            title="Core Team"
            subtitle="Experts Who took an Initiative"
          />

          <div className="row mt-5 justify-content-center">
            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
              <div className="team_member_card">
                <div className="image_div">
                  <img
                    className="memberimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/about-us/core-team/man2.jpeg"
                    }
                    alt="Team Member 1"
                  />
                </div>
                <div className="overlay"></div>
                <div className="member_info">
                  <h6 className="name">Shrikant Chandrakant Masule</h6>
                  <p className="position">Founder</p>
                  <div className="d-flex justify-content-center icondiv">
                    {/* 📧 Email */}
                    <a href="mailto:Shrikantmasule08@gmail.com">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="inner_icon"
                        />
                      </div>
                    </a>

                    <a href="tel:+916262171723">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faPhone}
                          className="inner_icon"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-6 col-sm-6 mb-4">
              <div className="team_member_card">
                <div className="image_div">
                  <img
                    className="memberimg"
                    src={
                      process.env.PUBLIC_URL +
                      "/assets/images/about-us/core-team/man3.jpeg"
                    }
                    alt="Team Member 1"
                  />
                </div>
                <div className="overlay"></div>
                <div className="member_info">
                  <h6 className="name">Mr. Vijay Baban Shinde</h6>
                  {/* <p className="position">MCA (Computer Application)</p> */}
                  <p className="position">Co-founder</p>
                  <div className="d-flex justify-content-center icondiv">
                    {/* 📧 Email */}
                     <a href="mailto:pythonbyvijay@gmail.com">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faEnvelope}
                          className="inner_icon"
                        />
                      </div>
                    </a>

                    <a href="tel:+919730145654">
                      <div className="icon_holder">
                        <FontAwesomeIcon
                          icon={faPhone}
                          className="inner_icon"
                        />
                      </div>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Core_team;
